import React, { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import eidWish from "../../images/eidWish.jpg";
import { AlertCircle } from "lucide-react";

export const TextPopupModal = ({ show, handleClose, text }) => {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        handleClose();
      }, 4000);
    }
  }, [show]);

  return (
    <Modal size="sm" show={show} centered>
      <Modal.Body>
        <div className="alertMsgModal">
          <div className="showMoreModalM">
            <div className="showMoreModal">
              {/* <div className="eidModalImg">
                <img src={eidWish} alt="eid mubarak" />
              </div> */}
              <div className="alertImg">
                <AlertCircle />
              </div>
              <h5 className="my-3 text-center">{text}</h5>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
